export const WEBLINK_REGEX =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

export const VALIDATION_ERROR_MESSAGE = 'Must be a valid weblink';
